<div class="table-container" [ngClass]="{'active': (tab==1)}">
    <div class="tabs-container">
        <div class="tabs">
            <h4 class="tab" [ngClass]="{'active': (cross_tab==1)}" (click)="cross_tab=1">Agregar Productos</h4>
            <h4 class="tab" [ngClass]="{'active': (cross_tab==2)}" (click)="cross_tab=2">Cross-Selling</h4>
            <h4 class="tab" [ngClass]="{'active': (cross_tab==3)}" (click)="cross_tab=3">Up-Selling</h4>

        </div>
    </div>
    <div class="table-container" [ngClass]="{'active': (cross_tab==1)}">
        <div class="body-tab">
            <div class="filters-container">
                <app-generic-select style="width: 300px;" [items]="categories"
                    (selectionChange)="onCategorySelect($event)" (loadMore)="loadMoreCategories()"
                    [placeholder]="'Categoría'" (cleared)="clearCategoryFilter()"
                    (searchChange)="onCategorySearch($event)">
                </app-generic-select>
                <app-generic-select style="width: 300px;" [placeholder]="'Marcas'" [items]="brands"
                    (loadMore)="loadMoreBrands()" (searchChange)="onBrandSearch($event)"
                    (selectionChange)="onBrandSelect($event)" (cleared)="clearBrandFilter()">
                </app-generic-select>
            </div>
            <div *ngIf="selectedProductIds.length > 0" class="buttons-container">
                <button class="button" (click)="updateCrossSellings()">Agregar como Cross-Selling</button>
                <button class="button" (click)="updateUpSellings()">Agregar como Up-Selling</button>
            </div>
        </div>
        <div class="container-card">
            <div class="product-card" *ngFor="let item of products; let i = index"
                (click)="toggleProductSelection(item.id)" [ngClass]="{
                    selected: selectedProductIds.includes(item.id),
                    disabled: item.id === id
                }">
                <div class="image-wrapper">
                    <div class="image-loader" *ngIf="!imageLoaded[i]">
                        <div class="spinner"></div>
                    </div>
                    <img
  [src]="item?.images?.[0]?.url || 'assets/images/product-placeholder.png'"
  alt="{{ item.name }}"
  (load)="imageLoaded[i] = true"
  (error)="onImageError($event, i)"
  [class.hidden]="!imageLoaded[i]" />
                </div>
                <p [title]="item.name"><span>{{item.name}}</span></p>
                <p>SKU: {{item.sku}}</p>
                <p>External ID: {{item.externalId}}</p>
            </div>
        </div>
        <div *ngIf="total > 21" class="pagination-container">
            <app-pagination *ngIf="cross_tab==1" [totalElements]="total" [pageSize]="27" [padding]="false"
                (selectPage)="selectPage($event)"></app-pagination>
        </div>
    </div>
    <div class="table-container" [ngClass]="{'active': (cross_tab==2)}">
        <div class="body-tab">
            <ng-container *ngIf="crosssellingsProducts && crosssellingsProducts.relatedSkus.length > 0; else emptyView">
                <table class="table">
                    <thead>
                        <th style="width: 70px;">Remover</th>
                        <th>Imagen</th>
                        <th>Nombre</th>
                        <th>SKU</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of crosssellingsProducts.relatedSkus">
                            <td>
                                <button class="trash-button" (click)="removeCrosssellingProduct(item.id)">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                            </td>
                            <td>
                                <img style="height: 50px;" src="{{item.relatedProductImg}}"
                                    alt="{{item.relatedProductName}}">
                            </td>
                            <td>
                                {{item.relatedProductName}}
                            </td>
                            <td>
                                {{item.relatedProductSku}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>
            <ng-template #emptyView>
                <div class="empty-view-container">
                    <img src="assets/images/icons/boxes.png" alt="boxes">
                    <h3>Este Producto aún no cuenta con Productos Cross-Sellings asociados.</h3>
                </div>
            </ng-template>
        </div>
    </div>
    <div class="table-container" [ngClass]="{'active': (cross_tab==3)}">
        <div class="body-tab">
            <ng-container *ngIf="upsellingsProducts && upsellingsProducts.relatedSkus.length > 0; else emptyViewUp">
                <table class="table">
                    <thead>
                        <th style="width: 70px;">Remover</th>
                        <th>Imagen</th>
                        <th>Nombre</th>
                        <th>SKU</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of upsellingsProducts.relatedSkus">
                            <td>
                                <button class="trash-button" (click)="removeUpsellingProduct(item.id)">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                            </td>
                            <td>
                                <img style="height: 50px;" src="{{item.relatedProductImg}}"
                                    alt="{{item.relatedProductName}}">
                            </td>
                            <td>
                                {{item.relatedProductName}}
                            </td>
                            <td>
                                {{item.relatedProductSku}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>
            <ng-template #emptyViewUp>
                <div class="empty-view-container">
                    <img src="assets/images/icons/boxes.png" alt="boxes">
                    <h3>Este Producto aún no cuenta con Productos Up-Sellings asociados</h3>
                </div>
            </ng-template>
        </div>
    </div>
</div>